
import { Center, Entity, Device } from "@/entities";
import { i18n } from "@/i18n";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import PIcon from "@/common/components/look/PIcon/PIcon.vue";
import { PButton, PModal } from "@/common/components";
import DeviceForm from "@/components/devices/device-form/DeviceForm.vue";
import { DeviceV2, RawDeviceV2 } from "@/entities/device";

@Component({
  name: "device-modal-service-point",
  i18n,
  components: {
    PModal,
    PIcon,
    PButton,
    DeviceForm,
  },
})
export class DeviceModal extends Vue {
  @Prop({ required: true }) value!: boolean;
  @Watch("value", { immediate: true, deep: true })
  onChangeValue(): void {
    this.showModal = this.value;
  }
  @Prop({ required: true }) center!: Center;
  @Prop({ required: true }) entity!: Entity;
  @Prop({ required: true }) device!: DeviceV2;
  @Prop({ required: false, default: true }) isModify!: boolean;
  @Prop({ required: false, default: "button.btn_save" }) textActionName!: string;
  showModal = false;

  closeModal(): void {
    this.showModal = false;
    this.$emit("input", false);
  }

  get titleModal(): string {
    return this.isModify
      ? this.$t("spPage.modal-device.modal_edit_title") + this.device.name
      : (this.$t("spPage.modal-device.modal_create_title") as string);
  }

  saveDevice(device: DeviceV2, update: boolean, action: string): void {
    if (update) {
      this.$services.device.updateDeviceV2(device).then(() => {
        Vue.swal({
          icon: "success",
          title: this.$i18n.t("spPage.modal-device.success"),
          showConfirmButton: false,
          timer: 2000,
        });
        this.$emit("refresh");
        this.closeModal();
      });
    } else {
      this.$services.device.createDeviceV2(device).then((response) => {
        Vue.swal({
          icon: "success",
          title: this.$i18n.t("spPage.modal-device.success_create"),
          showConfirmButton: false,
          timer: 2000,
        });
        this.$emit("refresh");
        if (action === "next") {
          device.id = response.aggregateId;
          this.$emit("next", device);
        } else {
          this.closeModal();
        }
      });
    }
  }
}

export default DeviceModal;
